import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IonAvatar, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonRouterLink, IonRouterOutlet, IonSpinner, IonSplitPane, IonThumbnail, IonToolbar } from '@ionic/angular/standalone';
import { Store, select } from '@ngrx/store';
import { addIcons } from "ionicons";
import { card, chatboxEllipses, logOut, person, planet, timer, globe } from "ionicons/icons";
import { filter, map, shareReplay, tap } from 'rxjs/operators';
import { signOut } from '../auth/state/auth/auth.actions';
import { loggedInUser } from '../auth/state/auth/auth.selectors';
import { loadSites } from '../state/sites/sites.actions';
import { selectAllSites } from '../state/sites/sites.selectors';
import { SynapsMediaApiService } from '../synaps-media-api.service';
import Logger from '../logger.service';
import { BetaFeaturesFacade } from '../state/beta-features/beta-features.facade';
import { DomainsFacade } from '../state/domains/domains.facade';
import { showToast } from '../auth/state/toast/toast.actions';
import { resendToken } from '../auth/state/auth/auth.actions';

const log = Logger('page:layout');

@Component({
  selector: 'app-layout',
  templateUrl: './layout.page.html',
  styleUrls: ['./layout.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonToolbar, IonHeader, RouterLink, RouterLinkActive, AsyncPipe, IonRouterLink, IonSplitPane, IonMenu, IonContent, IonList, IonItem, IonLabel, IonMenuToggle, IonAvatar, IonIcon, IonThumbnail, IonSpinner, IonFooter, IonRouterOutlet],
})
export class LayoutPage implements OnInit {
  betaFeaturesEnabled$ = this.betaFeaturesFacade.betaFeaturesEnabled$;

  activeUser$ = this.store.pipe(
    select(loggedInUser),
    tap((user) => log('user', user)),
    tap((user) => {
      if (!user.emailVerified) {
        this.store.dispatch(showToast({ message: 'Please verify your email address to continue!', color: 'warning', duration: 0, buttons: [{ text: 'Verify', handler: () => this.goToVerify() }]}));
      }
    }),
  );

  sites$ = this.store.pipe(select(selectAllSites)).pipe(
    filter(sites => sites !== null),
    map((sites) => sites.map((site) => ({
      ...site,
      info: {
        ...site.info,
        logo: site.info.logo?.startsWith('/') ? `${site.info.url}${site.info.logo}` : site.info.logo,
        icon: site.info.icon?.startsWith('/') ? `${site.info.url}${site.info.icon}` : site.info.icon,
        cover_image: site.info.cover_image?.startsWith('/') ? `${site.info.url}${site.info.cover_image}` : site.info.cover_image,
      },
    }))),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  portalUrl = this.api.billingPortalRedirectUrl;

  constructor(
    private store: Store,
    private api: SynapsMediaApiService,
    private domainsFacade: DomainsFacade,
    private router: Router,
    private betaFeaturesFacade: BetaFeaturesFacade,
  ) {
    addIcons({ planet, timer, card, person, globe, chatboxEllipses, logOut });
  }

  ngOnInit() {
    this.store.dispatch(loadSites());
    this.domainsFacade.loadDomains();
    this.betaFeaturesFacade.loadBetaFeatures();
  }

  goToVerify() {
    this.store.dispatch(resendToken());
    this.router.navigate(['/verify']);
  }

  help() {
    window.$chatwoot.setLabel('general-help');
    window.$chatwoot.toggle();
  }

  signOut() {
    this.store.dispatch(signOut());
  }
}
